import { createParser, system } from "../core";
import { getIsRtl } from "../utils/directionality";

var floatTransform = function floatTransform(value, _, props) {
  if (props === void 0) {
    props = {};
  }

  var map = {
    left: "right",
    right: "left"
  };
  return getIsRtl(props) ? map[value] : value;
};

var config = {
  animation: true,
  appearance: true,
  visibility: true,
  userSelect: true,
  pointerEvents: true,
  cursor: true,
  resize: true,
  objectFit: true,
  objectPosition: true,
  float: {
    property: "float",
    transform: floatTransform
  },
  willChange: true,
  filter: true
};
export var others = system(config);
export var othersParser = createParser(config);
//# sourceMappingURL=others.js.map